import { useEffect, useState } from "react";

export function useDebounce<V>(value: V, delay: number) {
  const [debouncedValue, setDebouncedValue] = useState<V>(value);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [value, delay]);

  return debouncedValue;
}
